import { render, staticRenderFns } from "./businessPlanWriting.vue?vue&type=template&id=e065147c"
import script from "./businessPlanWriting.vue?vue&type=script&lang=js"
export * from "./businessPlanWriting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports